import { callSP } from "setup/axios/AxiosCallSP";
import { IUser } from "../../interfaces/user.interface";
import { from, of } from "rxjs";
import { map, catchError, mergeMap, toArray, switchMap } from "rxjs/operators";
import { ICecoByUser } from "../../interfaces/ceco-by-user";
import IndexedDBService from "app/utils/Indexed-db-service/Indexed-db.service";
import { IRecipeBySites } from "../../interfaces/recipe-by-site";
import { setLStorage } from "global.d";

export class CacheSitesUserService {
    private cacheSites: { [key: number | string]: any } = [];
    private dbName: string = "dataSites";
    private idSites: string = "sites";
    private dbService: IndexedDBService;
    loadGetService = false;
    saveCache: boolean = false;
    //  new IndexedDBService("cacheSites", "sites");
    constructor() {
        this.dbService = new IndexedDBService(this.dbName, "sites");
        this.initDB();
        const saveCache = localStorage.getItem('saveCache')
        if (saveCache)
            this.saveCache = saveCache === 'true';
    }
    async initDB() {
        await this.dbService.init();
    }
    getCacheSitesPerUser(dataUser: IUser) {
        return from(callSP('amd_getCecosByUsert', [
            {
                text: 'idUsuario',
                value: dataUser.id.toString()
            }
        ])).pipe(
            switchMap((response: any) => {
                const results = response?.data?.result as ICecoByUser[];
                if (!Array.isArray(results) || results.length === 0) {
                    return of([]);
                }
                const sitesIds = this.extractUniqueSiteIds(results);
                if (sitesIds.length <= 3) {
                    this.saveCache = true;
                    this.loadGetService = true;

                    setLStorage("saveCache", this.saveCache);
                    return this.getArraySites(sitesIds);
                } else {
                    this.saveCache = false;
                    this.loadGetService = true;
                    setLStorage("saveCache", this.saveCache);
                    return of([]);
                }
            }),
            catchError((error) => {
                return of([]);
            })
        );
    }

    async getCacheSites() {
        if ((!this.cacheSites || this.cacheSites.length === 0) && this.saveCache) {
            try {
                const dataCache = await this.dbService.readItem(this.idSites);
                if (dataCache) {
                    this.cacheSites = dataCache.data;
                } else {
                    this.cacheSites = [];
                }
            } catch (error) {
                console.error(error);

            }
        }
        return this.cacheSites;
    }
    async getRecipeBySites(site: string) {
        const cacheService = new CacheSitesUserService();
        let dataResp: IRecipeBySites[] = [];
        const dataCacheSites: any = await cacheService.getCacheSites();
        if (dataCacheSites.length === 0 && !this.saveCache) {
            const dataSP = await callSP('amd_getRecetaByCeco', [
                { text: 'ceco', value: site.toString() },
            ])
            dataResp = dataSP.data.result;
        } else {
            if(dataCacheSites.length){
                dataResp = dataCacheSites[site.toString()];
            }else{
                return [];
            }
        }
        this.loadGetService = false;
        return dataResp;
    }

    private getArraySites(sitesIds: number[]) {

        return from(sitesIds).pipe(
            mergeMap(siteId =>
                from(callSP('amd_getRecetaByCeco', [
                    { text: 'ceco', value: siteId.toString() }
                ])).pipe(
                    catchError(error => {
                        console.error(`Error fetching data for siteId ${siteId}: ${error}`);
                        return of({ [siteId]: {} });
                    }),
                    map((response: any) => {
                        const results = response?.data?.result;                      
                        this.cacheSites[siteId] = results;
                        return { [siteId]: results };
                    })
                )
            ),
            toArray(),
            map(async _ => {
                this.loadGetService = false;
                if (this.dbService) {
                    await this.dbService.createItem({ id: this.idSites, data: this.cacheSites });
                }
                return this.cacheSites;
            })
        );
    }


    private extractUniqueSiteIds(data: ICecoByUser[]): number[] {
        return data.reduce((acc, current) => {
            if (!acc.includes(current.idSitio)) {
                acc.push(current.idSitio);
            }
            return acc;
        }, [] as number[]);
    }
}
